import { UUIDPathRegex } from '@cbgms/base/utils/uuid'

export const BasePath = `/returns`
export const AxaptaReturnPath = `${BasePath}/axapta-erp-return`
export const NewPath = `${BasePath}/new`
export const DetailsPath = `${BasePath}/:rmaUUID(${UUIDPathRegex})`
export const CreateInvoicePathPath = `${BasePath}/create-invoice`
export const RegisterPath = `${NewPath}/register-returns`
